import { Box, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

export const GRID_COLUMNS = 12;
export const ROW_HEIGHT = 120; // px per row unit
export const GRID_GAP = 12; // px between cells

/** Inner height a card gets for its content, given a row span */
export const cardContentHeight = (rowSpan: number) =>
  rowSpan * ROW_HEIGHT + (rowSpan - 1) * GRID_GAP;

const titleSx: SxProps<Theme> = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#161447",
};

type DashboardCardProps = {
  title?: string;
  colSpan?: number;
  rowSpan?: number;
  colStart?: number;
  children: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Base card for every analytics widget
 */
export const DashboardCard = ({
  title,
  colSpan = GRID_COLUMNS,
  rowSpan = 1,
  colStart,
  children,
  sx,
}: DashboardCardProps) => (
  <Box
    sx={{
      gridColumn: {
        xs: "1 / -1",
        md: colStart ? `${colStart} / span ${colSpan}` : `span ${colSpan}`,
      },
      gridRow: `span ${rowSpan}`,
      minWidth: 0,
      overflow: "hidden",
      borderRadius: "20px",
      background: (theme) => theme.palette.common.white,
      boxShadow: "0 4px 24px rgba(22, 20, 71, 0.04)",
      padding: "18px 22px",
      display: "flex",
      flexDirection: "column",
      ...sx,
    }}
  >
    {title && <Typography sx={titleSx}>{title}</Typography>}
    {children}
  </Box>
);
